import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

class AdminInd2 extends React.Component {
  state={permiteUpdate: true, confirmaAct: false, open: false
  }

  handleSubmit = async (ev)=>{
    document.body.style.cursor = 'wait'

    let argsQuery =`{$match: {tipoCoti: 'Cliente', estadoCoti: {$in: ['Enviada', 'Autorizada', 'Aprobada', 'Aceptada', 'Rechazada']}}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, fechaCreate: 1, validezOferta: 1, fechaEnvio: 1, fechaRta: 1, fechaAutOC: 1, fechaFin: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoCoti: 1, 
      nombreUsuario: 1, usuarioCreate: 1, usuarioEnvio: 1, usuarioAutOC: 1, tiempoEntrega: 1, trm: 1, monedaCoti: 1,
      cantidadCoti: '$itemsCoti.cantidadCoti', cantidadAprob: '$itemsCoti.cantidadAprob', 
      valorUniCoti: '$itemsCoti.valorUniCoti', valorUniAprob: '$itemsCoti.valorUniAprob', 
      porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
    {$match: {cantidadCoti: {$gt: 0}}},
    {$project: {_id: 1, fechaCreate: 1, validezOferta: 1, fechaEnvio: 1, fechaRta: 1, fechaAutOC: 1, fechaFin: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoCoti: 1, 
      nombreUsuario: 1, usuarioCreate: 1, usuarioEnvio: 1, usuarioAutOC: 1, tiempoEntrega: 1, trm: 1, monedaCoti: 1, 
      valorItemCoti: {
        $let: {
            vars: {cantidadCoti: {$toInt: '$cantidadCoti'}, valorUniCoti: '$valorUniCoti', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadCoti", {$multiply: [{$divide: ["$$valorUniCoti", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemAprob: {
        $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      }
    }},
    {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', validezOferta: '$validezOferta', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta', fechaAutOC: '$fechaAutOC', tipoCoti: '$tipoCoti', 
      fechaFin: '$fechaFin', tipo: '$tipo', numCoti: '$numCoti', descrEmpresa: '$descrEmpresa', estadoCoti: '$estadoCoti', nombreUsuario: '$nombreUsuario', 
      usuarioCreate: '$usuarioCreate', usuarioEnvio: '$usuarioEnvio', usuarioAutOC: '$usuarioAutOC', 
      tiempoEntrega: '$tiempoEntrega', trm: '$trm', monedaCoti: '$monedaCoti'},
      valorTotalCoti: {$sum: {$toDouble: '$valorItemCoti'}}, valorTotalAprob: {$sum: {$toDouble: '$valorItemAprob'}}
    }},
    {$project: {_id: '$_id._id', fechaCreate: '$_id.fechaCreate', validezOferta: '$_id.validezOferta', fechaEnvio: '$_id.fechaEnvio', fechaRta: '$_id.fechaRta', fechaAutOC: '$_id.fechaAutOC', tipoCoti: '$_id.tipoCoti', 
    fechaFin: '$_id.fechaFin', tipo: '$_id.tipo', numCoti: '$_id.numCoti', descrEmpresa: '$_id.descrEmpresa', estadoCoti: '$_id.estadoCoti', nombreUsuario: '$_id.nombreUsuario', 
      usuarioCreate: '$_id.usuarioCreate', usuarioEnvio: '$_id.usuarioEnvio', usuarioAutOC: '$_id.usuarioAutOC', 
      tiempoEntrega: '$_id.tiempoEntrega', trm: '$_id.trm', monedaCoti: '$_id.monedaCoti',
      valorUniCoti: {$toDouble: '$valorTotalCoti'}, valorUniAprob: {$toDouble: '$valorTotalAprob'}
    }},
    {$project: {_id: 1, fechaCreate: 1, validezOferta: 1, fechaEnvio: 1, fechaRta: 1, fechaAutOC: 1, fechaFin: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoCoti: 1, 
      nombreUsuario: 1, usuarioCreate: 1, usuarioEnvio: 1, usuarioAutOC: 1, tiempoEntrega: 1, trm: 1, monedaCoti: 1, valorUniCoti: 1, valorUniAprob: 1}},
    {$sort: {fechaCreate: 1}}`

  let argsQuery1 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', estadoOC: {$ne: 'Cancelada'}, 'numOrdenCompra': {$gt: 0}}},
    {$project: {_id: 1, fechaAutOC: 1, fechaEjec: 1, fechaRta: 1, fechaFin: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, 
      nombreUsuarioOC: 1, usuarioAutOC: 1, tiempoEntrega: 1, fechaOrdenCliente: 1}},   
    {$sort: {fechaAutOC: 1}}`

  let argsQuery2 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', estadoOC: {$ne: 'Cancelada'}, 'numOrdenCompra': {$gt: 0}}},
    {"$unwind": "$itemsFactura"},
    {$project: {_id: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, trm: 1, monedaCoti: 1, pais: 1, 
      fechaSolic: '$itemsFactura.fechaSolic', fechaFact: '$itemsFactura.fechaFact', numAvance: {"$toString": "$itemsFactura.numAvance"}, 
      usuarioSolic: '$itemsFactura.usuarioSolic', usuarioFact: '$itemsFactura.usuarioFact', valorFact: '$itemsFactura.valorFact', valorFactSinIva: '$itemsFactura.valorFactSinIva', 
      valorPagado: '$itemsFactura.valorPagado', trmFactura: '$itemsFactura.trmFactura', numFactura: '$itemsFactura.numFactura'}},
    {$project: {_id: {$concat: ['$numCoti', '$numAvance']}, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, trm: 1, 
      monedaCoti: 1, pais: 1, fechaSolic: 1, fechaFact: 1, numAvance: 1, usuarioSolic: 1, usuarioFact: 1, valorFact: 1, 
      valorPagado: 1, trmFactura: 1, numFactura: 1}},
    {$sort: {fechaFact: 1}}  
    `

    let argsQuery3 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', estadoOC: {$ne: 'Cancelada'}, 'numOrdenCompra': {$gt: 0}}},
    {"$unwind": "$itemsPagos"},
    {$project: {_id: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, trm: 1, monedaCoti: 1, 
      fechaRegPago: '$itemsPagos.fechaRegPago', fechaCreate: {"$toString": "$itemsPagos.fechaRegPago"}, 
      valorPago: '$itemsPagos.valorPago', valorRetencion: '$itemsPagos.valorRetencion', 
      valorAjuste: '$itemsPagos.valorAjuste', usuarioRegPago: '$itemsPagos.usuarioRegPago', trmPago: '$itemsPagos.trmPago'}},
    {$project: {_id: {$concat: ['$numCoti', '$fechaCreate']}, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, trm: 1, monedaCoti: 1, 
      fechaRegPago: 1, valorPago: 1, valorRetencion: 1, valorAjuste: 1, usuarioRegPago: 1, trmPago: 1}},
    {$sort: {fechaSolic: 1}}`
    
    let argsQuery4 = `{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      valorFact: '$itemsFactura.valorFact', 
      valorPagado: {
        $let: {
            vars: {valorPago: '$itemsFactura.valorPagado'},
            in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
        }
      },
      numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
      venceFact: '$itemsFactura.venceFact'
    }}, 
    {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      valorFact: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, 
      totalOC: {
        $let: {
            vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
            in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
        }
      }
  }},
  {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 
  {$sort: {numFactura: 1}}`


  let xlsStringM = []
  let xlsString1M = []
  xlsString1M = ['Fecha', 'Año', 'Mes', 'Num_Mes', 'Comercial', 'Grupo', 'Meta', 'Ventas', '% Cumplimiento', 'Rango', 'Comisión proyectada', 'Comisión recaudo', 'Meta año', 'Acumulado año', '% Cumplimiento año']
  xlsStringM.push(xlsString1M)

  let estructuraM = this.props.allMetaRtes.allMetaRtes

  console.log(estructuraM)

  if(estructuraM.length>0){   
    for(let ii=0; ii<estructuraM.length; ii++){
      let allUsuariosM = await this.props.allUsuarios.allUsuarios
      let indexUsu = allUsuariosM.findIndex( usuario => usuario.nombreUsuario===estructuraM[ii].nombreUsuario )
      if(indexUsu!==-1 && allUsuariosM[indexUsu].estado==='Activo'){
        xlsString1M = []
        let campoMes=''
        if(estructuraM[ii].mesNum < 10){ 
          campoMes='0' + estructuraM[ii].mesNum
        }else{
          campoMes = estructuraM[ii].mesNum
        }
        let fecha = estructuraM[ii].agno + '-' + campoMes + '-01'
        let usuMeta=''
        if(estructuraM[ii].tipoMeta==='Comercial'){
          usuMeta=estructuraM[ii].nombreUsuario
        }
        if(estructuraM[ii].tipoMeta==='Facturación'){
          usuMeta='Facturación'
        }
        xlsString1M = [fecha, estructuraM[ii].agno, estructuraM[ii].mes, estructuraM[ii].mesNum, usuMeta, 
        estructuraM[ii].grupo?estructuraM[ii].grupo:'Sin grupo', estructuraM[ii].meta, estructuraM[ii].valorReal, 
        estructuraM[ii].porcCumplimientoMeta, estructuraM[ii].rangoAplicado, 
        estructuraM[ii].comisionVentas?estructuraM[ii].comisionVentas:0, estructuraM[ii].valorComision?estructuraM[ii].valorComision:0,
        estructuraM[ii].metaAgno?estructuraM[ii].metaAgno:0, estructuraM[ii].valorRealAcumAgno?estructuraM[ii].valorRealAcumAgno:0, 
        estructuraM[ii].porcCumplimientoMetaAgno?estructuraM[ii].porcCumplimientoMetaAgno:0]

        xlsStringM.push(xlsString1M)
      }
    }
  }

  let xlsStringT = []
  let xlsString1T = []
  xlsString1T = ['Usuario', 'Cédula', 'Inicio', 'Fin', 'Horas_Turno']
  xlsStringT.push(xlsString1T)

  let estructuraT = this.props.allTurnoRtes.allTurnoRtes

  if(estructuraT.length>0){   
    for(let ii=0; ii<estructuraT.length; ii++){
      xlsString1T = []
      let numHoras= 0
        if(estructuraT[ii].minutosTotalTurno && estructuraT[ii].minutosTotalTurno>0){
          numHoras=parseFloat(estructuraT[ii].minutosTotalTurno/60).toFixed(1)
        }

      xlsString1T = [estructuraT[ii].nombreUsuario, estructuraT[ii].cedula, estructuraT[ii].fechaHoraIniTurno.substr(0, 10), 
      estructuraT[ii].fechaHoraFinTurno.substr(0, 10), numHoras]

      xlsStringT.push(xlsString1T)
    }
  }


  let xlsString = []
    let xlsString1 = []
    xlsString1 = ['Tipo informe', 'Fecha creación', 'Fecha envío', 'Fecha respuesta', 'Fecha asignación', 'Fecha compromiso', 'Fecha cierre OC', 
            'Fecha solic. Fact.', 'Fecha facturación', 'Fecha recaudo', 'Días envío cot.', 'Días Rta cliente', 'Días asig. OC', 'Días compromiso', 
            'Días cierre OC', 'Días Facturación', 'Días Recaudo', 'Cotización', 'Empresa', 'Tipo venta', 'Estado actual', 'Usuario cotiza',
            'Ejecutivo comercial', 'Usuario envío', 'Usuario asigna OC', 'Responsable OC', 'Usuario facturación', 'Usuario recaudo', 
            'Valor cotizado', 'Valor venta', 'Valor facturado', 'Valor recaudo', 'Valor retención', 'Valor ajuste', 'Moneda', 'TRM', 
            'Cumplimiento', 'Enviadas', 'Respondidas', 'Pendiente Rta', 'Aceptadas', 'Rechazadas', 'Pendiente inicio OC', 
            'Abiertas', 'Cerradas', 'Vencidas', 'No vigentes', 'No enviadas', 'País']
    xlsString.push(xlsString1)
  
    let argsBuscarCoti = {tipoqry: `[${argsQuery}]`}

    let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
    let estructura = await data.allCotizacionRtes

    if(estructura.length>0){   
      let allUsuarios = await this.props.allUsuarios.allUsuarios
      // let allEmpresa = await this.props.allEmpresa.allEmpresa

      for(let ii=0; ii<estructura.length; ii++){
        xlsString1 = []
        let numDiasEnv=0, numDiasRta=0, numDiasAsig=0, enviadas=1, respuestas=0, iniciadas=0, diasComp=0
        let aceptadas=0, rechazadas=0, sinRta=0, sinIni=0, vencidas=0, no_vigente=0, no_enviada=0
        let valorCoti=estructura[ii].valorUniCoti, valorVenta=estructura[ii].valorUniAprob
        let usuarioEnvio= '', usuarioCreate=''
        let trmValor=parseFloat(estructura[ii].trm)
        let indexUsu = allUsuarios.findIndex( usuario => usuario.email===estructura[ii].usuarioCreate )
        if(indexUsu===-1){
          usuarioCreate= estructura[ii].usuarioCreate
        }else{
          usuarioCreate= allUsuarios[indexUsu].nombreUsuario
        }

        if(estructura[ii].estadoCoti==='Aprobada'){
          no_enviada=1
          enviadas=0
        }else{
          indexUsu = allUsuarios.findIndex( usuario => usuario.email===estructura[ii].usuarioEnvio )
          if(indexUsu===-1){
            usuarioEnvio= estructura[ii].usuarioEnvio
          }else{
            usuarioEnvio= allUsuarios[indexUsu].nombreUsuario
          }
          
          numDiasEnv = moment(estructura[ii].fechaEnvio, 'YYYY-MM-DD').diff(moment(estructura[ii].fechaCreate, 'YYYY-MM-DD'), 'days') 
          switch(estructura[ii].tiempoEntrega){
            case '2-5 días hábiles':
              diasComp=6;
              break
            case '6-9 días hábiles':
              diasComp=10;
              break
            case 'A convenir':
              diasComp=0;
              break
            case '> 10 días hábiles':
              diasComp=15;
            break
          }
          if(estructura[ii].fechaRta){
            respuestas=1
            numDiasRta = moment(estructura[ii].fechaRta, 'YYYY-MM-DD').diff(moment(estructura[ii].fechaEnvio, 'YYYY-MM-DD'), 'days') 
            if(estructura[ii].estadoCoti==='Aceptada'){
              aceptadas=1
              if(estructura[ii].fechaAutOC){
                iniciadas=1
                numDiasAsig = moment(estructura[ii].fechaAutOC, 'YYYY-MM-DD').diff(moment(estructura[ii].fechaRta, 'YYYY-MM-DD'), 'days') 
              }else{
                sinIni=1
                numDiasAsig = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura[ii].fechaRta, 'YYYY-MM-DD'), 'days')
                let diasRta = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura[ii].fechaRta, 'YYYY-MM-DD'), 'days')
                if(estructura[ii].fechaFin){
                  let diasFin = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura[ii].fechaFin, 'YYYY-MM-DD'), 'days') 
                  if(parseInt(diasRta)<parseInt(diasFin)){
                    diasComp = moment(estructura[ii].fechaFin, 'YYYY-MM-DD').diff(moment(estructura[ii].fechaRta, 'YYYY-MM-DD'), 'days') 
                  }
                }
                if(parseInt(diasRta)>=parseInt(diasComp)){
                  vencidas=1
                }
              }
            }else{
              rechazadas=1
            }
          }else{
            sinRta=1
            let validez=0
            let fechaHoy = new Date()
            fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
            fechaHoy=moment(fechaHoy)
            var fecEnv=moment(estructura[ii].fechaEnvio).format('YYYY-MM-DD')
            let numDias= fechaHoy.diff(fecEnv, 'days')-1 
            switch(estructura[ii].validezOferta){
              case '1 día':
                validez=1;
                break
              case '3 días':
                validez=3;
                break
              case '8 días':
                validez=8;
                break
              case '15 días':
                validez=15;
                break
              case '30 días':
                validez=30;
                break
              case '60 días':
                validez=60;
                break
              case '90 días':
                validez=90;
                break  
            }
            if(estructura[ii].numCoti === 'COT-LCM-AXE-CP-061224-4'){
              console.log(estructura[ii].estadoCoti, numDias, estructura[ii].validezOferta, validez, estructura[ii].fechaEnvio, fechaHoy, fecEnv)
            }
            if(estructura[ii].estadoCoti==='Enviada' && parseInt(numDias)>parseInt(validez)){
              no_vigente=1
            } 
          }
        }
        if(estructura[ii].monedaCoti==='Dolares'){
          valorCoti=parseInt(valorCoti*trmValor)
          valorVenta=parseInt(valorVenta*trmValor)
        }

        xlsString1 = ['Comercial', estructura[ii].fechaCreate.substr(0, 10), estructura[ii].fechaEnvio?estructura[ii].fechaEnvio.substr(0, 10):'', 
        estructura[ii].fechaRta?estructura[ii].fechaRta.substr(0, 10):'', estructura[ii].fechaAutOC?estructura[ii].fechaAutOC.substr(0, 10):'', 
        estructura[ii].fechaFin?estructura[ii].fechaFin.substr(0, 10):'', '', '', '', '', numDiasEnv, numDiasRta, numDiasAsig, diasComp, 0, 0, 0,
        estructura[ii].numCoti, estructura[ii].descrEmpresa, estructura[ii].tipo, estructura[ii].estadoCoti, estructura[ii].usuarioCreate, 
        estructura[ii].nombreUsuario, usuarioEnvio, estructura[ii].usuarioAutOC?estructura[ii].usuarioAutOC:'', '', '', '',
        valorCoti, valorVenta, 0, 0, 0, 0, estructura[ii].monedaCoti, estructura[ii].trm?estructura[ii].trm:0, 0, 
        enviadas, respuestas, sinRta, aceptadas, rechazadas, sinIni, 0, 0, vencidas, no_vigente, no_enviada]

        xlsString.push(xlsString1)
    }

    argsBuscarCoti = {tipoqry: `[${argsQuery1}]`}

    if(2>1){
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
      let estructura1 = await data.allCotizacionRtes

      if(estructura1.length>0){       
        for(let ii=0; ii<estructura1.length; ii++){
          xlsString1 = []
          let numDiasAsig=0, numDiasComp=0, numDiasCierre=0, numDiasVenc=0, cumplimiento=100, abiertas=0, cerradas=0, vencidas=0
          numDiasAsig = moment(estructura1[ii].fechaAutOC, 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaRta, 'YYYY-MM-DD'), 'days') 
          switch(estructura1[ii].tiempoEntrega){
            case '2-5 días hábiles':
              numDiasComp=6;
              break
            case '6-9 días hábiles':
              numDiasComp=10;
              break
            case 'A convenir':
              numDiasComp=0;
              break
            case '> 10 días hábiles':
              numDiasComp=15;
            break
          }
          if(estructura1[ii].fechaFin){
            let diasFin = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaFin, 'YYYY-MM-DD'), 'days') 
            let diasRta = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days')
            if(parseInt(diasRta)>parseInt(diasFin)){
              numDiasComp = moment(estructura1[ii].fechaFin, 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days') 
            }
          }
          if(estructura1[ii].diasImportacion && estructura1[ii].diasImportacion>0){
            numDiasComp+=estructura1[ii].diasImportacion
          }
          let numDiasHoy = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days')
          if(estructura1[ii].estadoOC!=='Aprobada'){
            cerradas=1
            if(estructura1[ii].fechaEjec){
              numDiasCierre = moment(estructura1[ii].fechaEjec, 'YYYY-MM-DD').diff(moment(estructura1[ii].fechaOrdenCliente, 'YYYY-MM-DD'), 'days')
            }else{
              numDiasCierre = numDiasComp
            }
            if(parseInt(numDiasComp)>0 && parseInt(numDiasCierre)>parseInt(numDiasComp)){
              numDiasVenc=parseInt(numDiasCierre)-parseInt(numDiasComp)
              if(parseInt(numDiasVenc)>parseInt(numDiasComp)){
                cumplimiento=0
              }else{
                cumplimiento=parseInt(100-(numDiasVenc*(100/numDiasComp)))
              }
            } 
          }else{
            abiertas=1
            if(parseInt(numDiasComp)>0 && parseInt(numDiasHoy)>parseInt(numDiasComp)){
              numDiasVenc=parseInt(numDiasHoy)-parseInt(numDiasComp)
            }
          }
          if(parseInt(numDiasVenc)>0){
            vencidas=1
          }

          xlsString1 = ['Logística', '', '', estructura1[ii].fechaOrdenCliente?estructura1[ii].fechaOrdenCliente.substr(0, 10):'', estructura1[ii].fechaAutOC?estructura1[ii].fechaAutOC.substr(0, 10):'', 
          estructura1[ii].fechaFin?estructura1[ii].fechaFin.substr(0, 10):'', 
          estructura1[ii].fechaEjec?estructura1[ii].fechaEjec.substr(0, 10):'', '', '', '', 0, 0, numDiasAsig, numDiasComp, numDiasCierre, 0, 0,
          estructura1[ii].numCoti, estructura1[ii].descrEmpresa, estructura1[ii].tipo, estructura1[ii].estadoOC, '', 
          '', '', estructura1[ii].usuarioAutOC, estructura1[ii].nombreUsuarioOC, '', '', 
          0, 0, 0, 0, 0, 0, '', 0, cumplimiento, 0, 0, 0, 0, 0, 0, abiertas, cerradas, vencidas, 0, 0]

          xlsString.push(xlsString1)
        }
      }
    }

  if(2>1){}
    argsBuscarCoti = {tipoqry: `[${argsQuery2}]`}

    let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
    let estructura2 = await data.allCotizacionRtes

    if(estructura2.length>0){       
      for(let ii=0; ii<estructura2.length; ii++){
        xlsString1 = []
        let numDiasFact=0, abiertas=0, cerradas=0, vencidas=0
        let valorFact=estructura2[ii].valorFact, valorPagado=estructura2[ii].valorPagado?estructura2[ii].valorPagado:0
        let valorFactSinIva=estructura2[ii].valorFactSinIva?estructura2[ii].valorFactSinIva:0
        let trmValor=1
        let usuarioFactura= ''
        if(estructura2[ii].trmFactura){
          trmValor=parseFloat(estructura2[ii].trmFactura)
        }else{
          if(estructura2[ii].trm){
            trmValor=parseFloat(estructura2[ii].trm)
          }
        }
        if(estructura2[ii].monedaCoti==='Dolares'){
          valorFact=parseInt(valorFact*trmValor)
          valorFactSinIva=parseInt(valorFactSinIva*trmValor)
          valorPagado=parseInt(valorPagado*trmValor)
        }
        if(valorFactSinIva>0){
          valorFact=valorFactSinIva
        }

        if(estructura2[ii].numFactura){
          cerradas=1
          numDiasFact = moment(estructura2[ii].fechaFact, 'YYYY-MM-DD').diff(moment(estructura2[ii].fechaSolic, 'YYYY-MM-DD'), 'days')
          if(parseInt(numDiasFact)>3){
            vencidas=1
          } 
          let indexUsu = allUsuarios.findIndex( usuario => usuario.email===estructura2[ii].usuarioFact )
          if(indexUsu===-1){
            usuarioFactura= estructura2[ii].usuarioFact
          }else{
            usuarioFactura= allUsuarios[indexUsu].nombreUsuario
          }
        }else{
          abiertas=1
          let numDiasSolic = moment(new Date(), 'YYYY-MM-DD').diff(moment(estructura2[ii].fechaSolic, 'YYYY-MM-DD'), 'days')
          if(parseInt(numDiasSolic)>3){
            vencidas=1
          }
        }
        
        


        xlsString1 = ['Facturación', '', '', '', '', '', '', estructura2[ii].fechaSolic.substr(0, 10), 
        estructura2[ii].fechaFact?estructura2[ii].fechaFact.substr(0, 10):'', '', 0, 0, 0, 0, 0, numDiasFact, 0,
        estructura2[ii].numCoti, estructura2[ii].descrEmpresa, estructura2[ii].tipo, estructura2[ii].estadoOC, '', 
        '', '', '', '', usuarioFactura, '', 
        0, 0, valorFact, valorPagado, 0, 0, estructura2[ii].monedaCoti, trmValor, 0, 0, 0, 0, 0, 0, 0, abiertas, cerradas, vencidas, 0, 0, estructura2[ii].pais?estructura2[ii].pais:'Colombia']

        xlsString.push(xlsString1)
      }
    }
  }

  if(2>1){
    argsBuscarCoti = {tipoqry: `[${argsQuery4}]`}

    let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
    let estructura4 = await data.allCotizacionRtes

    if(estructura4.length>0){       
      for(let ii=0; ii<estructura4.length; ii++){
        xlsString1 = []
        let numDiasFact=0, vencidas=0, trmValor=0
        let valorFact=estructura4[ii].valorFact, valorPagado=estructura4[ii].valorPagado?estructura4[ii].valorPagado:0
        let estadoFact='Vigente'
        if(estructura4[ii].trmFactura){
          trmValor=parseFloat(estructura4[ii].trmFactura)
        }else{
          if(estructura4[ii].trm){
            trmValor=parseFloat(estructura4[ii].trm)
          }
        }
        if(estructura4[ii].monedaCoti==='Dolares'){
          valorFact=parseInt(valorFact*trmValor)
          valorPagado=parseInt(valorPagado*trmValor)
        }
        let saldo=valorFact-valorPagado
        if(estructura4[ii].venceFact){
          let fechaHoy = new Date()
          fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          fechaHoy=moment(fechaHoy)
          var fecFin=moment(estructura4[ii].venceFact).format('YYYY-MM-DD')
          let numDias= fechaHoy.diff(fecFin, 'days') 
          if(numDias>0){
            vencidas = 1
            numDiasFact=parseInt(numDias)
            estadoFact='Vencida'
          }
        }

        xlsString1 = ['Cartera', '', '', '', '', estructura4[ii].venceFact?estructura4[ii].venceFact.substr(0, 10):'', '', '', 
        '', '', 0, 0, 0, 0, 0, numDiasFact, 0,
        estructura4[ii].numCoti, estructura4[ii].descrEmpresa, estructura4[ii].tipo, estadoFact, '', 
        '', '', '', '', '', '', 
        0, 0, valorFact, valorPagado, saldo, 0, estructura4[ii].monedaCoti, trmValor, 0, 0, 0, 0, 0, 0, 0, 0, 0, vencidas, 0, 0]

        xlsString.push(xlsString1)
      }
    }
  }

    if(2>1){
      argsBuscarCoti = {tipoqry: `[${argsQuery3}]`}

      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
      let estructura3 = await data.allCotizacionRtes

      if(estructura3.length>0){       
        let allUsuarios = await this.props.allUsuarios.allUsuarios
        for(let ii=0; ii<estructura3.length; ii++){
          xlsString1 = []
          let valorPago=estructura3[ii].valorPago
          let trmValor=0
          let usuarioPago= ''
          if(estructura3[ii].trmPago){
            trmValor=parseFloat(estructura3[ii].trmPago)
          }else{
            if(estructura3[ii].trm){
              trmValor=parseFloat(estructura3[ii].trm)
            }
          }
          if(estructura3[ii].monedaCoti==='Dolares'){
            valorPago=parseInt(valorPago*trmValor)
          }

            let indexUsu = allUsuarios.findIndex( usuario => usuario.email===estructura3[ii].usuarioRegPago )
            if(indexUsu===-1){
              usuarioPago= estructura3[ii].usuarioRegPago
            }else{
              usuarioPago= allUsuarios[indexUsu].nombreUsuario
            }

          xlsString1 = ['Recaudo', '', '', '', '', '', '', '', 
          '', estructura3[ii].fechaRegPago.substr(0, 10), 0, 0, 0, 0, 0, 0, 0,
          estructura3[ii].numCoti, estructura3[ii].descrEmpresa, estructura3[ii].tipo, estructura3[ii].estadoOC, '', 
          '', '', '', '', '', usuarioPago, 
          0, 0, 0, valorPago, 0, 0, estructura3[ii].monedaCoti, trmValor, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

          xlsString.push(xlsString1)
        

          if(ii===estructura3.length-1){
            var wb = XLSX.utils.book_new();

            wb.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb.SheetNames.push("Administrativo");

            let ws_data = xlsString;

            let ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets["Administrativo"] = ws;
            let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
            function s2ab(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Administrativo.xlsx');

            var wb1 = XLSX.utils.book_new();
            wb1.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb1.SheetNames.push("Metas");

            let ws_data1 = xlsStringM;

            let ws1 = XLSX.utils.aoa_to_sheet(ws_data1);
            wb1.Sheets["Metas"] = ws1;
            let wbout1 = XLSX.write(wb1, {bookType:'xlsx',  type: 'binary'});
            function s2ab1(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab1(wbout1)],{type:"application/octet-stream"}), 'Metas.xlsx');

            var wb2 = XLSX.utils.book_new();
            wb2.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb2.SheetNames.push("Turnos");

            let ws_data2 = xlsStringT;

            let ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
            wb2.Sheets["Turnos"] = ws2;
            let wbout2 = XLSX.write(wb2, {bookType:'xlsx',  type: 'binary'});
            function s2ab2(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab2(wbout2)],{type:"application/octet-stream"}), 'Turnos.xlsx');


  //FIN Exportar a XLS
          }
        }
      }
  

    }
    document.body.style.cursor = 'default'
  }
    




  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {permiteUpdate, confirmaAct, open} = this.state;
    let mensaje = "Descargar matríz en Excel"
    let imgIcon = "images/documento_32.png"

    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: ''}}]`}}}}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: {$in: ['Comercial', 'Facturación']}}}, {$sort: {estado: 1, agno: -1, mesNum: -1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allTurnoRtes, {name:'allTurnoRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estado: 'Cerrado', nombreUsuario: {$nin: ['slcm', 'slcm1 Pruebas']}}}]`}}}}),

)(AdminInd2)
